import {ConfigProvider} from 'antd'
import {ReactNode} from 'react'
import locale from 'antd/es/locale/zh_CN'

const AndtConfigProvider = ({children}: {children: ReactNode}) => {
	return (
		<ConfigProvider
			locale={locale}
			theme={{
				token: {
					colorPrimary: '#00C18A'
				},
				components: {
					Tabs: {
						titleFontSize: 18
					},
					Checkbox: {
						colorBorder: '#D8D8D8',
						fontSize: 12,
						lineHeight: 1.5,
						colorText: '#717B86',
						marginXS: 18
					},
					Input: {
						colorTextPlaceholder: '#959FAC',
						colorText: '#5E6872'
					}
				}
			}}
		>
			{children}
		</ConfigProvider>
	)
}

export default AndtConfigProvider
